import { NumberBadgeSx } from '@/components/blocks/FreeGiftV2/styles/freeGift';
import { Box } from '@mui/material';

interface NumberBadgeProps {
	num: number;
}

export const NumberBadge = ({ num }: NumberBadgeProps) => (
	<Box component="span" sx={NumberBadgeSx.bagdeContainer}>
		{num}
	</Box>
);
